import request from "root/js/request";

export const getWarehouseSupplyDistributionSummary = async ({
  category_id__in,
  brand_id__in,
  supplier_article__in,
  barcode__in,
  subject_id__in,
  barcode_id__not_in,

  cabinet_id,
  sales_share_history_period,
  sales_share_weight,
  by_subject_share_weight,
  exclude_region_clusters,
  isRegion,
  forecast_period,
  with_seasonality,
  with_in_way_stocks,
  with_seasonality_spikes,
  with_mp_growth,
  with_trend,
  with_abc_xyz_cz_excluded,
  with_cancel_share,
  with_return_share,
  with_company_plan,
  fbo_share,
}) => {
  const response = await request({
    url: "/analytics/forecasting/warehouse_supply_distribution_summary_by_regions/",
    method: "get",
    params: {
      cabinet_id,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      barcode__in,
      subject_id__in,
      barcode_id__not_in,

      sales_share_history_period,
      sales_share_weight,
      by_subject_share_weight,
      exclude_region_clusters,
      is_excluded: isRegion,
      forecast_period,
      with_seasonality,
      with_in_way_stocks,
      with_seasonality_spikes,
      with_mp_growth,
      with_trend,
      with_abc_xyz_cz_excluded,
      with_cancel_share,
      with_return_share,
      with_company_plan,
      fbo_share,
    },
  });
  return response.data;
};
